export default {
  FETCH_STOCK_REPORT: 'FETCH_STOCK_REPORT',
  FETCH_STOCK_REPORT_SUCCESS: 'FETCH_STOCK_REPORT_SUCCESS',
  DOWNLOAD_STOCK_REPORT: 'DOWNLOAD_STOCK_REPORT'
}
